import { render, staticRenderFns } from "./ClientHistoryWidget.vue?vue&type=template&id=4f4af453&"
import script from "./ClientHistoryWidget.vue?vue&type=script&lang=js&"
export * from "./ClientHistoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports